// 20.1.2.4 Number.isNaN(number)
var $export = require('./_export');

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});



//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/~/core-js/modules/es6.number.is-nan.js
// module id = ../../../../core-js/modules/es6.number.is-nan.js
// module chunks = 15